import { gql } from '@apollo/client'

export const UPDATE_CHANNEL = gql`
  mutation UpdateChannel($input: UpdateChannelInput!) {
    updateChannel(input: $input) {
      channel {
        id
        name
        description
        allowComments
        publishAuthorName
        followersCount
      }
      errors
    }
  }
`
